/**
 * DevPage
 * This is DevPage API contract
 *
 * OpenAPI spec version: 1.1.0
 * Contact: apiteam@swagger.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ArticlesSearchResult } from '../model/articlesSearchResult';
import { ErrorResponse } from '../model/errorResponse';
import { SimpleArticlesSearchResult } from '../model/simpleArticlesSearchResult';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class SearchArticlesService {

    protected basePath = 'http://localhost:8090';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {

        if (configuration) {
            this.configuration = configuration;
            this.configuration.basePath = configuration.basePath || basePath || this.basePath;

        } else {
            this.configuration.basePath = basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Get articles
     * 
     * @param amount 
     * @param word 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getArticles(amount: number, word?: string, observe?: 'body', reportProgress?: boolean): Observable<ArticlesSearchResult>;
    public getArticles(amount: number, word?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ArticlesSearchResult>>;
    public getArticles(amount: number, word?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ArticlesSearchResult>>;
    public getArticles(amount: number, word?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (amount === null || amount === undefined) {
            throw new Error('Required parameter amount was null or undefined when calling getArticles.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (word !== undefined && word !== null) {
            queryParameters = queryParameters.set('word', <any>word);
        }
        if (amount !== undefined && amount !== null) {
            queryParameters = queryParameters.set('amount', <any>amount);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<ArticlesSearchResult>(`${this.configuration.basePath}/articles/link/search`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get articles for banner
     * 
     * @param bannerName 
     * @param amount 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getArticlesByBannerType(bannerName: string, amount: number, observe?: 'body', reportProgress?: boolean): Observable<SimpleArticlesSearchResult>;
    public getArticlesByBannerType(bannerName: string, amount: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SimpleArticlesSearchResult>>;
    public getArticlesByBannerType(bannerName: string, amount: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SimpleArticlesSearchResult>>;
    public getArticlesByBannerType(bannerName: string, amount: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (bannerName === null || bannerName === undefined) {
            throw new Error('Required parameter bannerName was null or undefined when calling getArticlesByBannerType.');
        }
        if (amount === null || amount === undefined) {
            throw new Error('Required parameter amount was null or undefined when calling getArticlesByBannerType.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (bannerName !== undefined && bannerName !== null) {
            queryParameters = queryParameters.set('bannerName', <any>bannerName);
        }
        if (amount !== undefined && amount !== null) {
            queryParameters = queryParameters.set('amount', <any>amount);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<SimpleArticlesSearchResult>(`${this.configuration.basePath}/articles/banner/search`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
